export const getAutorization = () => {
  const auth = localStorage.getItem("auth_data");
  const autorization = auth ? JSON.parse(auth)?.state?.authorizationData : null;
  return autorization;
};
